// chunkError.ts — stale-chunk (post-deploy) failure detection + one-shot
// guarded auto-reload, shared by RouteErrorBoundary/RouteErrorElement.
// Lives outside the component file so react-refresh/only-export-components
// stays green (same split as FE-3's stateGraphIds.ts).

const CHUNK_RELOAD_FLAG = 'vharta_chunk_reload_attempted'

/** True if `error` looks like a stale-chunk dynamic-import failure. */
export function isChunkLoadError(error: unknown): boolean {
  if (!error) return false
  const name = (error as { name?: unknown }).name
  if (name === 'ChunkLoadError') return true
  const message = error instanceof Error ? error.message : String(error)
  return /Loading chunk|Failed to fetch dynamically imported module/i.test(message)
}

/**
 * Reloads the page once per browser session for a chunk-load failure.
 * sessionStorage-guarded so a genuinely broken deploy (chunk missing for
 * every request, not just a stale cache) shows the manual Reload button on
 * the second failure instead of looping forever. Returns true if a reload
 * was actually triggered (test hook), false if the guard blocked it.
 */
export function attemptChunkAutoReload(): boolean {
  try {
    if (sessionStorage.getItem(CHUNK_RELOAD_FLAG)) {
      return false
    }
    sessionStorage.setItem(CHUNK_RELOAD_FLAG, '1')
  } catch {
    // sessionStorage unavailable (private browsing, etc.) — reload anyway;
    // there's no way to guard against a loop in that environment, but that
    // matches pre-existing behavior (no guard existed for anything before).
  }
  window.location.reload()
  return true
}
